import React from "react";
import ProductRaport from "./ProductRaport";

const ProductRaportAll = () => {
  return (
    <>
      <ProductRaport />
    </>
  );
};

export default ProductRaportAll;
